import { AddPredictionsAutocomplete } from '@modules/feedback/components/AddPredictionsAutocomplete';
import { ReasonSuggestions } from '@modules/feedback/components/FeedbackDetails/utils/getReasonSuggestionsFromSuggestedReasons';
import { Feedback } from 'v2/core/entities/feedback';

interface AddPredictionsProps {
  feedback: Feedback;
  isOpen: boolean;
  onClose: () => void;
  reasonSuggestions: ReasonSuggestions[];
  areReasonSuggestionsLoading: boolean;
  isDetailView: boolean;
}

export const AddPredictions = ({
  feedback,
  isOpen,
  onClose,
  reasonSuggestions,
  areReasonSuggestionsLoading,
  isDetailView,
}: AddPredictionsProps) => {
  return (
    <AddPredictionsAutocomplete
      onClose={onClose}
      isOpen={isOpen}
      feedbackID={feedback.id}
      isDetailView={isDetailView}
      reasonSuggestions={reasonSuggestions}
      feedbackLabels={feedback.labels}
      areReasonSuggestionsLoading={areReasonSuggestionsLoading}
    />
  );
};
